import bowser from 'bowser';

export const minBrowserVersions = {
	chrome: '56'
};

export const minOsVersions = {
	mac: '10.9',
	ios: '9999', // intentionally high since not supported yet
	android: '9999' // intentionally high since not supported yet
};

// List of browsers supported by legacy app
export const legacyBrowsers = ['msie', 'msedge', 'safari'];

// List of operating systems detected by bowser
export const osNames = {
	mac: 'Mac OS',
	windows: 'Windows',
	windowsphone: 'Windows Phone',
	linux: 'Linux',
	chromeos: 'Chrome OS',
	android: 'Android',
	ios: 'iOS',
	blackberry: 'Blackberry',
	firefoxos: 'Firefox OS',
	webos: 'WebOS',
	bada: 'Bada',
	tizen: 'Tizen',
	sailfish: 'Sailfish'
};

export const getBrowserInfoFn = bowser => () => {
	return `${bowser.name} ${bowser.version}`;
};

export const getBrowserInfo = getBrowserInfoFn(bowser);

export const getOsInfoFn = (bowser, osNames) => () => {
	const os = Object.keys(osNames).filter(key => !!bowser[key]).shift();
	let info = osNames[os] || 'Unknown OS';
	if (bowser.osversion) {
		info += ` ${bowser.osversion}`;
	}
	return info;
};

export const getOsInfo = getOsInfoFn(bowser, osNames);

export const isSupportedBrowserFn = (bowser, minBrowserVersions) => () => {
	// Check min browser versions
	return bowser.check(minBrowserVersions, true);
};

export const isSupportedBrowser = isSupportedBrowserFn(bowser, minBrowserVersions);

export const isLegacyBrowserFn = (bowser, legacyBrowsers) => () => {
	const browsers = legacyBrowsers.filter(browser => !!bowser[browser]);
	return browsers.length > 0;
};

export const isLegacyBrowser = isLegacyBrowserFn(bowser, legacyBrowsers);

export const isSupportedPlatformFn = (bowser, minOsVersions) => () => {
	// Check OS compatibility
	if (bowser.android && isSupportedBrowser) //gets around a bug with chrome with dev tools open reporting platform as android
		return true;
	return Object.keys(minOsVersions).reduce((accumulator, key) => {
		if (bowser[key]) {
			const version = minOsVersions[key];
			const osVersion = bowser.osversion || '0';
			return accumulator && bowser.compareVersions([version, osVersion]) <= 0;
		}
		return accumulator;
	}, true);
};

export const isSupportedPlatform = isSupportedPlatformFn(bowser, minOsVersions);



// WEBPACK FOOTER //
// ./src/services/platformDetector.js